var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 -960 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280-280q-83.333 0-141.667-58.28Q80-396.561 80-479.819q0-83.258 58.333-141.72Q196.667-680 280-680q61.692 0 112.616 34.461 50.923 34.462 71.743 90.718H880v149.642h-88.103V-280H648.41v-125.179H464.359q-20.82 56.256-71.743 90.718Q341.692-280 280-280Zm0-33.846q67.795 0 109.41-42.526 41.616-42.525 49.664-82.654h244.824v125.18h74.153v-125.18h88.103v-81.948H439.026q-8-40.129-49.616-82.654-41.615-42.526-109.41-42.526-69.039 0-117.596 48.534-48.558 48.533-48.558 117.538t48.558 117.621Q210.961-313.846 280-313.846Zm0-120.821q18.667 0 32-13.333 13.333-13.333 13.333-32T312-512q-13.333-13.333-32-13.333T248-512q-13.333 13.333-13.333 32T248-448q13.333 13.333 32 13.333ZM280-480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.1f241116f4ca99345dcb9c8db795c69c.svg";
export { ForwardRef as ReactComponent };